module.exports = __webpack_public_path__ + "assets/img/gzh_qrcode.091e20c8.png";